import axios from 'axios';
import API from './API';


export const Templates_Add = (data) => API.post('Templates/Add', data);
export const Templates_Get_All = () => {
  return API.get("Templates/Get_All");
};
export const Templates_Get = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.get(`Templates/Get/${ID}`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};
export const Templates_Delete = (ID) => {
  const Token = localStorage.getItem("Token");
  return API.delete(`Templates/Delete/${ID}`, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
}

export const Templates_Initialize = () => {
  const Token = localStorage.getItem("Token");
  return API.post(`Templates/Initialize`, {}, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};

export const Templates_Update = (data) => {
  const Token = localStorage.getItem("Token");
  return API.post(`Templates/Update`, data, {
    headers: {
      Authorization: `Bearer ${Token}`
    }
  });
};
